import React, { useEffect } from 'react';
import * as SDCCore from 'scandit-web-datacapture-core';
import * as SDCBarcode from 'scandit-web-datacapture-barcode';
import * as utility from '../../utils/utility'

import I18n  from '../../localization';
import "./scanditScanner.scss";
import PopUp from '../PopUp';
import CustomQrPopup from '../CustomQrPopup';

import PubSub from 'pubsub-js'
import { EVSE_NATIVE_METHODS } from '../../utils/constant';
class scanditScannerPlugin extends React.Component {

constructor(props) {
  super(props);
  this.barcodeCapture = null
  this.isProcessing = false
  this._isMounted = false
  this.state = {
    qrCodePopup: false,
  }
}


  rejectBarcodeUniversal(session, barcode) {
    if (typeof session.reject === "function") {
      session.reject(barcode);          // Web
    } else if (typeof session.rejectBarcode === "function") {
      session.rejectBarcode(barcode);   // iOS/Android Native
    } else {
      console.warn("No reject method found in session");
    }
  }
componentDidMount() {
  this._isMounted = true
    const run = async () => {
      const view = new SDCCore.DataCaptureView();
      view.connectToElement(document.getElementById('scandit-barcode-picker'));
      view.showProgressBar();
      const svgLoader = document.createElement('div');
      svgLoader.innerHTML = `<div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><svg class="loaderV3" width="60px" height="60px" viewBox="0 0 80 80"><circle fill="#fff" cx="40" cy="40" r="35" opacity="0.5"></circle><circle fill="none" cx="40" cy="40" r="20" stroke="#01B5DE" stroke-dasharray="95 84" stroke-width="3px" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 40 40" to="360 40 40" dur="1s" repeatCount="indefinite"></animateTransform></circle></svg><span>${I18n.t('mobile.common.loading')}...</span></div>`;
      const progressBar = document.querySelector('.scandit-paintboards scandit-loading-overlay').shadowRoot.querySelector('.loading-overlay');
      progressBar.innerHTML = ''
      progressBar.appendChild(svgLoader)

      //Torch Icon 
      const torchIcon = document.createElement('div')
      const camera = SDCCore.Camera.default;
      const toggleTorch = async () => {
        try {
          const currentTorchState = await camera.getDesiredTorchState();
          await camera.setDesiredTorchState(currentTorchState == 'on' ? 'off' : 'on');
          updateTorchIcon();
        } catch (error) {
          console.error('Error toggling torch:', error);
        }
      };
      const checkAppActiveState = () => {
        const appChangeState = function (event, data) {
            const state = utility.removeBackslash(data.data)
            const state2 = utility.removeBackslash(data)
            if((state === 'background' || state2 === 'background')){
              const currentTorchState = camera.getDesiredTorchState();
              if(currentTorchState == 'on'){
                toggleTorch()
              }
            }
        }
        PubSub.subscribe(EVSE_NATIVE_METHODS.NOTIFY_LIFECYCLE_STATE, appChangeState);
      }
      checkAppActiveState()
      const updateTorchIcon = async () => {
        try {
          const currentTorchState = await camera.getDesiredTorchState();
          const newTorchIconHTML = currentTorchState == 'on' ?
          `<div style="display: flex; flex-direction: row-reverse; padding-right:8px; padding-top: 12px; pointer-events: auto">
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
            <g id="Group_19120" data-name="Group 19120" transform="translate(-279 -213)">
              <rect id="Rectangle_7189" data-name="Rectangle 7189" width="36" height="36" rx="18" transform="translate(279 213)" fill="#151515" opacity="0.6"/>
              <path id="flashlight_on_FILL0_wght400_GRAD0_opsz24" d="M8,22V11L6,8V2H18V8l-2,3V22Zm4-6.5a1.5,1.5,0,1,1,1.062-.438A1.444,1.444,0,0,1,12,15.5ZM8,5h8V4H8Zm8,2H8v.4l2,3V20h4V10.4l2-3ZM12,12Z" transform="translate(285 219)" fill="#fff"/>
            </g>
          </svg>
        </div>` : `<div style="display: flex; flex-direction: row-reverse; padding-right:8px; padding-top: 12px; pointer-events: auto">
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
            <g id="Group_19396" data-name="Group 19396" transform="translate(-279 -213)">
              <rect id="Rectangle_7189" data-name="Rectangle 7189" width="36" height="36" rx="18" transform="translate(279 213)" fill="#151515" opacity="0.6"/>
              <path id="flashlight_off_FILL0_wght400_GRAD0_opsz24" d="M74.757-859l-3.874-3.874v3.262H62.728v-11.417L56-877.757l1.427-1.427,18.757,18.757Zm-9.99-2.65h4.078v-3.262l-4.078-4.078Zm6.117-6.983-2.039-2.039v-.765l2.039-3.058v-.408H64.614l-2.039-2.039h8.308v-1.019H61.556l-.867-.867V-880H72.922v6.117l-2.039,3.058ZM66.806-866.951ZM67.239-872.278Z" transform="translate(231 1101)" fill="#fff"/>
            </g>
          </svg>
        </div>`;
          if (torchIcon.firstChild) {
            torchIcon.removeChild(torchIcon.firstChild);
          }
          torchIcon.insertAdjacentHTML('beforeend', newTorchIconHTML);
        } catch (error) {
          console.error('Error updating torch icon:', error);
        }
      };
      if (camera) {
        torchIcon.addEventListener('click', toggleTorch);
        updateTorchIcon();
      }
      //Info Icon
      const infoIcon = document.createElement('div');
      infoIcon.innerHTML = `<div style="display: flex; flex-direction: row-reverse; padding-right:8px; padding-top: 12px; pointer-events: auto">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
          <g id="Group_19394" data-name="Group 19394" transform="translate(-323 -213)">
            <rect id="Rectangle_7188" data-name="Rectangle 7188" width="36" height="36" rx="18" transform="translate(323 213)" fill="#151515" opacity="0.6"/>
            <path id="info_FILL0_wght400_GRAD0_opsz24" d="M11,17h2V11H11Zm1-8a.984.984,0,1,0-.712-.288A.968.968,0,0,0,12,9Zm0,13a9.732,9.732,0,0,1-3.9-.788A9.978,9.978,0,0,1,2.788,15.9,9.732,9.732,0,0,1,2,12a9.732,9.732,0,0,1,.788-3.9A9.984,9.984,0,0,1,8.1,2.787,9.743,9.743,0,0,1,12,2a9.743,9.743,0,0,1,3.9.787A9.984,9.984,0,0,1,21.212,8.1,9.732,9.732,0,0,1,22,12a9.732,9.732,0,0,1-.788,3.9A9.978,9.978,0,0,1,15.9,21.212,9.732,9.732,0,0,1,12,22Zm0-2a7.721,7.721,0,0,0,5.675-2.325A7.721,7.721,0,0,0,20,12a7.721,7.721,0,0,0-2.325-5.675A7.721,7.721,0,0,0,12,4,7.721,7.721,0,0,0,6.325,6.325,7.721,7.721,0,0,0,4,12a7.721,7.721,0,0,0,2.325,5.675A7.721,7.721,0,0,0,12,20ZM12,12Z" transform="translate(329 219)" fill="#fff"/>
          </g>
        </svg>
      </div>`
      infoIcon.addEventListener('click', () => handleInfoIconClick() )
      const cameraSection = document.querySelector('.scandit-controls');
      cameraSection.innerHTML = '';
      if(!utility.isiOS()){
        cameraSection.appendChild(torchIcon)
      }
      cameraSection.appendChild(infoIcon);
      const handleInfoIconClick = () => {
        this.setState({ qrCodePopup: true })
      }
      try {
        await SDCCore.configure({
          licenseKey: this.props.scanditLicenseKey,
          libraryLocation:
            'https://cdn.jsdelivr.net/npm/scandit-web-datacapture-barcode@6.x/build/engine/',
          moduleLoaders: [
            SDCBarcode.barcodeCaptureLoader({ highEndBlurryRecognition: false }),
          ],
        });

      const context = await SDCCore.DataCaptureContext.create();
      await view.setContext(context);
      const camera = SDCCore.Camera.default;
      const cameraSettings = SDCBarcode.BarcodeCapture.recommendedCameraSettings;

      if (camera) {
        await camera.applySettings(cameraSettings);
      }
      await context.setFrameSource(camera);

      const settings = new SDCBarcode.BarcodeCaptureSettings();
      settings.enableSymbologies([
        SDCBarcode.Symbology.DataMatrix,
        SDCBarcode.Symbology.QR,
        SDCBarcode.Symbology.Code128, 
        SDCBarcode.Symbology.Code39,    
        SDCBarcode.Symbology.EAN8,     
        SDCBarcode.Symbology.UPCE
      ]);

const code128Settings = settings.settingsForSymbology(SDCBarcode.Symbology.Code128);
code128Settings.isColorInvertedEnabled = true;

      Object.values(SDCBarcode.Symbology).forEach(sym => {
        try {
          settings.settingsForSymbology(sym).isColorInvertedEnabled = true;
        } catch (e) {}
      });

      this.barcodeCapture = await SDCBarcode.BarcodeCapture.forContext(
        context,
        settings
      );
      await this.barcodeCapture.setEnabled(false);

      this.barcodeCapture.addListener({
        didScan: (barcodeCapture, session, _) => {
          if (this.isProcessing || !this._isMounted || !this.barcodeCapture) return;

          const barcode = session.newlyRecognizedBarcode;
          var separateLines = barcode.data.match(/[^\r\n]+/g);
          const value = separateLines[0];
          if (value.length !== 15) {
            console.warn("Rejected Code128 because length ≠ 15:", value);
            this.rejectBarcodeUniversal(session, barcode);
            return;
          }
            if(separateLines[0].match('([0-9]{2})?')){
                this.isProcessing = true;
                try { this.barcodeCapture.setEnabled(false); } catch(e) {}

                const scannedValue = separateLines[0];
                const rawData = barcode.data;

                setTimeout(async () => {
                  try {
                    await this.props.qrCodeSuccessCallback(scannedValue, rawData);
                  } catch (err) {
                    console.warn("qrCodeSuccessCallback error:", err);
                  }

                  if (!this._isMounted) return;

                  try {
                    if (this.barcodeCapture) {
                      await this.barcodeCapture.setEnabled(true);
                    }
                  } catch (err) {
                    console.warn("Scanner re-enable error:", err);
                  } finally {
                    this.isProcessing = false;
                  }
                }, 0);
            }
        },
      });
      const barcodeCaptureOverlay = await SDCBarcode.BarcodeCaptureOverlay.withBarcodeCaptureForViewWithStyle(
        this.barcodeCapture,
        view,
        SDCBarcode.BarcodeCaptureOverlayStyle.Frame
      );

      const viewfinder = new SDCCore.RectangularViewfinder(
        SDCCore.RectangularViewfinderStyle.Square,
        SDCCore.RectangularViewfinderLineStyle.Light
      );

      await barcodeCaptureOverlay.setViewfinder(viewfinder);
      await camera.switchToDesiredState(SDCCore.FrameSourceState.On);
      await this.barcodeCapture.setEnabled(true);
      view.hideProgressBar();

      } catch (error) {
        console.log(error);
        if(utility.isiOS()) {
          if (error.name ==  "NotAllowedError") {
            this.props.iosCameraPermissionsDenied()
          }
        }
      }
    };
    run()
  };

  componentWillUnmount() {
  this._isMounted = false
  this.isProcessing = false
  try {
    if (this.barcodeCapture) {
      const ctx = this.barcodeCapture.context;
      this.barcodeCapture.removeListener();
      this.barcodeCapture = null;
      if (ctx) {
        ctx.dispose();
      }
    }
  } catch (err) {
      console.warn('Error during Scandit cleanup:', err);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.isProcessing) return;
    if(!this.props.scanStatus && this.barcodeCapture){
      this.barcodeCapture.setEnabled(false);
    }else if(this.props.scanStatus && this.barcodeCapture){
      this.barcodeCapture.setEnabled(true);
    }
  }


  render() {
    const { qrCodePopup } = this.state;
  return (
    <>
    <div>
      <div id="scandit-barcode-picker" style={{width: '100vw', height: '450px',}}></div>
    </div>
    <PopUp
    open={qrCodePopup}
    handleClose={() => this.setState({ qrCodePopup: false })}
    zIndex={10001}
    content={
        <CustomQrPopup
                title={I18n.t('mobile.AirDeviceProvisioning.iqAirHubPopupMsg')}
                rightAction={() => {
                this.setState({ qrCodePopup: false })
          }}
          icon={"qrScanner"}
          isNaAnimation={this.props?.getNACountriesAnimation()}
          rightButtonText={I18n.t('mobile.common.okayGotIt')}
          provisioningType={this.props?.provisioningType}
        />
    }
    />
  </>
  );
  }
};

export default scanditScannerPlugin;
